<template>

    <div class="page-header">

        <transition name="modal">
            <v-modal-user-verify v-if="!user.verified_at && showModal === 'verify-email'" />
        </transition>

        <h1 class="page-title">
            <v-page-icon :loading="loading" :symbol="icon" />
            <span v-if="title" v-html="title"></span>
            <slot v-else></slot>
        </h1>

        <div class="page-alerts">
            <v-page-alert v-if="company.is_suspended">
                <span>Company temporarily suspended. Please contact support.</span>
            </v-page-alert>
            <v-page-alert v-else-if="!user.verified_at">
                <span>Verify your email to activate account.&nbsp;<a href="#" @click.prevent="$store.commit('showModal', 'verify-email')">Resend Link</a></span>
            </v-page-alert>
            <v-page-alert v-else-if="company.is_trialing">
                <span>Your trial ends {{ company.trial_ended_at | relativeTime }}.&nbsp;<router-link :to="{ name: 'billing' }">Upgrade Plan</router-link></span>
            </v-page-alert>
            <v-page-alert v-else-if="company.customers_limit > 0 && company.customers_count >= company.customers_limit">
                <span>Customer limit reached.&nbsp;<router-link :to="{ name: 'billing' }">Upgrade Plan</router-link></span>
            </v-page-alert>
            <v-page-alert v-else-if="company.monthly_email_limit > 0 && company.monthly_email_count >= company.monthly_email_limit">
                <span>Monthly email limit reached.&nbsp;<router-link :to="{ name: 'billing' }">Upgrade Plan</router-link></span>
            </v-page-alert>
            <v-page-alert v-else-if="company.is_paused">
                <router-link :to="{ name: 'billing' }">Upgrade Plan</router-link>
            </v-page-alert>
        </div>

    </div>

</template>

<style scoped lang="scss">

    .page-header {
        align-items: center;
        background: #fff;
        border-bottom: 1px solid $color-rule;
        box-sizing: border-box;
        display: flex;
        flex-shrink: 0;
        height: $header-height;
        justify-content: space-between;
        left: 0;
        padding: 10px 15px;
        position: relative;
        top: 0;
        width: 100%;
    }

    .page-title {
        @include font-semibold(16px);
        align-items: center;
        color: $color-text;
        display: flex;
    }

</style>

<script>

import ModalUserVerify from '@modals/user/ModalUserVerify';

export default {

    components: {
        'v-modal-user-verify': ModalUserVerify,
    },

    props: {
        title: {
            type: String,
        },
        icon: {
            type: String,
        },
    },

    computed: {

        loading() {
            return this.$store.getters.loading;
        },

        user() {
            return this.$store.getters.user;
        },

        company() {
            return this.$store.getters.company;
        },

    },

}

</script>
